import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=0f7df0cf&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f7df0cf')) {
      api.createRecord('0f7df0cf', component.options)
    } else {
      api.reload('0f7df0cf', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=0f7df0cf&", function () {
      api.rerender('0f7df0cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ZkCiUwGu0bS4/JS/offershelp.vue"
export default component.exports